import { useCallback, useEffect, useState } from 'react';
import { getAllAutogiroMandate } from 'src/shared/services/autogiroMandateService';

/** Returns the number of unlinked autogiro mandates and a refetch function */
export const useAutogiroUnlinkedBadge = (enabled = true): [number, () => void] => {
  const [count, setCount] = useState(0);

  const fetch = useCallback(() => {
    if (!enabled) return;
    getAllAutogiroMandate({ pageIndex: 0, pageSize: 1, sortCol: 'autogiroMandate_id', sortDir: 'desc', filter: '', linkedFilter: 'unlinked' })
      .then((res) => {
        setCount(res.data.totalItems);
      })
      .catch(() => undefined);
  }, [enabled]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return [count, fetch];
};
